import type { DeepPartial } from "@/domains/library"
import { deepMerge } from "@/domains/library"
import useResponsive, { ResponsiveMode } from "@/hooks/use-responsive"

import type { FontConfig, FullFontConfig } from "../types"

export function useFontConfig<T extends FontConfig>({
  baseConfig,
  options,
  mode,
}: {
  baseConfig: T
  options?: DeepPartial<T>
  mode?: ResponsiveMode
}): FullFontConfig | undefined {
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const config = options ? deepMerge(baseConfig, options) : baseConfig

  if (mode) {
    if (mode === "mobile") {
      return config.mobile
    } else if (mode === "tablet") {
      return config.tablet
    } else if (mode === "desktop") {
      return config.desktop
    }
  }

  if (isMobile) {
    return config.mobile
  } else if (isTablet) {
    return config.tablet
  } else if (isDesktop) {
    return config.desktop
  }

  return undefined
}
